import { render, staticRenderFns } from "./ApplicationForm.vue?vue&type=template&id=65031c55&scoped=true"
import script from "./ApplicationForm.vue?vue&type=script&lang=js"
export * from "./ApplicationForm.vue?vue&type=script&lang=js"
import style0 from "./ApplicationForm.vue?vue&type=style&index=0&id=65031c55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65031c55",
  null
  
)

export default component.exports